var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoOfCoachesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F5F5F5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_838_5966",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_838_5966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20C18.9 20 17.9583 19.6083 17.175 18.825C16.3917 18.0417 16 17.1 16 16C16 14.9 16.3917 13.9583 17.175 13.175C17.9583 12.3917 18.9 12 20 12C21.1 12 22.0417 12.3917 22.825 13.175C23.6083 13.9583 24 14.9 24 16C24 17.1 23.6083 18.0417 22.825 18.825C22.0417 19.6083 21.1 20 20 20ZM12 28V25.2C12 24.6333 12.1458 24.1125 12.4375 23.6375C12.7292 23.1625 13.1167 22.8 13.6 22.55C14.6333 22.0333 15.6833 21.6458 16.75 21.3875C17.8167 21.1292 18.9 21 20 21C21.1 21 22.1833 21.1292 23.25 21.3875C24.3167 21.6458 25.3667 22.0333 26.4 22.55C26.8833 22.8 27.2708 23.1625 27.5625 23.6375C27.8542 24.1125 28 24.6333 28 25.2V28H12ZM14 26H26V25.2C26 25.0167 25.9542 24.85 25.8625 24.7C25.7708 24.55 25.65 24.4333 25.5 24.35C24.6 23.9 23.6917 23.5625 22.775 23.3375C21.8583 23.1125 20.9333 23 20 23C19.0667 23 18.1417 23.1125 17.225 23.3375C16.3083 23.5625 15.4 23.9 14.5 24.35C14.35 24.4333 14.2292 24.55 14.1375 24.7C14.0458 24.85 14 25.0167 14 25.2V26ZM20 18C20.55 18 21.0208 17.8042 21.4125 17.4125C21.8042 17.0208 22 16.55 22 16C22 15.45 21.8042 14.9792 21.4125 14.5875C21.0208 14.1958 20.55 14 20 14C19.45 14 18.9792 14.1958 18.5875 14.5875C18.1958 14.9792 18 15.45 18 16C18 16.55 18.1958 17.0208 18.5875 17.4125C18.9792 17.8042 19.45 18 20 18Z",
    fill: "#1853A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoOfCoachesIcon);
export default __webpack_public_path__ + "static/media/no_of_coaches_icon.442479bee15ecffe378e6bd4a44afa6a.svg";
export { ForwardRef as ReactComponent };